import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "meetingInput", "meetingId"]
  static values = { projectId: Number }

  showLinkModal() {
    this.modalTarget.classList.remove("hidden")
    if (this.hasMeetingInputTarget) {
      this.meetingInputTarget.value = ""
      this.meetingInputTarget.focus()
    }
    if (this.hasMeetingIdTarget) {
      this.meetingIdTarget.value = ""
    }
  }

  hideLinkModal() {
    this.modalTarget.classList.add("hidden")
  }

  async linkMeeting() {
    const meetingId = this.meetingIdTarget.value

    if (!meetingId) {
      alert("Please select a meeting")
      return
    }

    try {
      const response = await fetch(`/projects/${this.projectIdValue}/link_meeting`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
        },
        body: JSON.stringify({ meeting_id: meetingId })
      })

      const data = await response.json()

      if (response.ok && data.success) {
        window.location.reload()
      } else {
        alert(data.error || "Failed to link meeting")
      }
    } catch (error) {
      console.error("Error linking meeting:", error)
      alert("An error occurred. Please try again.")
    }
  }

  async unlinkMeeting(event) {
    const meetingId = event.currentTarget.dataset.meetingId

    if (!confirm("Unlink this meeting from the project?")) {
      return
    }

    try {
      const response = await fetch(`/projects/${this.projectIdValue}/unlink_meeting`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
        },
        body: JSON.stringify({ meeting_id: meetingId })
      })

      const data = await response.json()

      if (response.ok && data.success) {
        window.location.reload()
      } else {
        alert(data.error || "Failed to unlink meeting")
      }
    } catch (error) {
      console.error("Error unlinking meeting:", error)
      alert("An error occurred. Please try again.")
    }
  }
}

